import PromotionsInnerPage from './PromotionsInnerPage';
export default PromotionsInnerPage;
